<template>
  <div class="pageWrap">
    <iframe :src="pageUrl" frameborder="0" class="pageFrame" :style="{height:outHeight}"></iframe>
  </div>
</template>
<script>

export default {
  name: '',
  components:{

  },
  created() {
    let url = this.$route.query.pageUrl
    this.pageUrl = url+"?isweb=isweb"+"&webHost="+process.env.VUE_APP_H5_HOST;

    let _sh = document.documentElement.clientHeight;
    let _outHeight = _sh - 46;
    this.outHeight = _outHeight + "px"
  },
  mounted() {
    
  },
  data () {
    return {
      pageUrl: '',
      outHeight: 0
    }
  },
  methods: {

  }
}
</script>
<style scoped lang='less'>
.pageWrap{
  width:100%;
  position: relative;
}
.pageFrame{
  width:100%;
  height:100%;
}
.share{
  position: absolute;
  z-index:999;
  left:50px;
  top:50px;
  background: red;
}
</style>